import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import client, { endpoints } from '../api/client';

const CATS = ['Guide', 'Tutorial', 'Blog', 'Case study'];

export default function WriteArticle() {
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();
  const [f, setF] = useState({ title: '', excerpt: '', tags: '', coverImage: '', category: 'Guide', body: '', status: 'published' });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  if (!user) return <div className="container community narrow"><h1>Write an article</h1><p className="muted"><Link to="/login">Sign in</Link> to write an article.</p></div>;

  async function submit(e) {
    e.preventDefault(); setErr(null);
    try { const { data } = await client.post(endpoints.articles.create, f); navigate(`/articles/${data.slug}`); }
    catch (e) { setErr(e?.response?.data?.error || 'Failed'); }
  }
  return (
    <div className="container community narrow">
      <h1>Write an article</h1>
      <form onSubmit={submit} className="form">
        <label>Title<input value={f.title} onChange={set('title')} required /></label>
        <label>Excerpt<input value={f.excerpt} onChange={set('excerpt')} placeholder="One-line summary (optional)" /></label>
        <div className="row2">
          <label>Tags<input value={f.tags} onChange={set('tags')} placeholder="tag1, tag2" /></label>
          <label>Category<select value={f.category} onChange={set('category')}>{CATS.map((c) => <option key={c}>{c}</option>)}</select></label>
        </div>
        <label>Cover image URL<input value={f.coverImage} onChange={set('coverImage')} /></label>
        <label>Body<textarea rows={14} value={f.body} onChange={set('body')} required /></label>
        <button className="btn-primary">Publish</button>
        {err && <p className="err">{err}</p>}
      </form>
    </div>
  );
}
